import styles from "./ReproxyLink.module.scss";
//import ports_icon from "@assets/redesign/icons/ports.svg";
import ports_icon from "@assets/icons/ports.svg";
import Icon from "@components/global/new/Icon/Icon";
import { IReproxyLink } from "@services/getMinerList";
import SmallLink from "@components/global/new/SmallLink/SmallLink";

export interface ReproxyLinkProps {
  readonly minerId: number;
  readonly link?: IReproxyLink;
  onDoPortClicked: (minerId: number, prevPort: number) => void;
  onDeletePortClicked?: (minerId: number, port: number) => void;
}

export default function ReproxyLink({
  minerId,
  link,
  onDoPortClicked,
  onDeletePortClicked,
}: ReproxyLinkProps): JSX.Element {

  // const minerPortsCache = useMinerReproxyPortsCache();

  return (
    <div className={`${styles.reproxy_container} active`}>
      {link && link.Port > 0 && (
        <>
          <SmallLink
            className="bold_orange"
            onClick={() => {
              onDoPortClicked(minerId, link.Port);
            }}
          >
            [&nbsp;{link.Port}&nbsp;]
          </SmallLink>
          &nbsp;
        </>
      )}
      {onDeletePortClicked && link && link.Port > 0 && (
        <>
          <SmallLink
            className="red_bold"
            onClick={() => {
              if (link && link.Port > 0) {
                onDeletePortClicked(minerId, link.Port);
              }
            }}
          >
            X
          </SmallLink>
          &nbsp;
        </>
      )}
      {link === undefined && (
        <Icon
          src={ports_icon}
          title={"Access miner"}
          onClick={() => {
            onDoPortClicked(minerId, -1);
          }}
        />
      )}
    </div>
  );
}